var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-stepper',{attrs:{"alt-labels":""},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1"}}),_c('v-divider'),_c('v-stepper-step',{attrs:{"step":"2"}}),_c('v-divider'),_c('v-stepper-step',{attrs:{"step":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }